"use client"

import { isPastEvent } from "@/utils/datehelpers"
import SignupForm from "@/components/SignupForm/SignupForm"
import { getFormId } from "@/utils/merge"

export default function SignupFormWrapper({ data, texts }) {
  const isOnline = data.type === "online"

  if (isPastEvent(data.date_time, data.time_zone)) {
    return null
  }

  return (
    <SignupForm
      isOnline={isOnline}
      form_id={data.form_id && data.form_id != 0 ? data.form_id : getFormId()}
      bottomText={data.form_bottom_text}
    />
  )
}
